<script setup lang="ts">
import {onBeforeUnmount, ref, watch} from "vue";
import dayjs from "dayjs";
import {Button} from "@/Components/Library";
import useEcho from "@/Composables/echo";
import {getAppVersion} from "@/Services/notifications";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
const show = ref(false);
let pollInterval: number | undefined;
// console.log(pollInterval);
const reload = () => window.location.reload();
const isUpdateAvailable = (appVersion: string) => Boolean($store.appVersion && $store.appVersion !== appVersion);

const checkForUpdate = async () => {
    // console.log(`checkForUpdate: ${dayjs().format("HH:mm:ss")}`, pollInterval, $store.user.id);
    try {
        const {app_version: appVersion} = await getAppVersion();
        // console.log(`appVersion response: ${dayjs().format("HH:mm:ss")}`, $store.appVersion, appVersion);
        show.value = isUpdateAvailable(appVersion);
    } catch {}
};

useEcho(
    [
        {
            event: "UpdateAvailable",
            callback: ({app_version: appVersion}: {app_version: string}) => {
                show.value = isUpdateAvailable(appVersion);
            },
        },
    ],
    "app-updates",
);

const startPolling = () => {
    // console.log(`startPolling: ${dayjs().format("HH:mm:ss")}`, pollInterval, $store.user.id);
    if (pollInterval !== undefined || !$store.user.id) {
        return;
    }

    checkForUpdate();
    pollInterval = window.setInterval(checkForUpdate, 5 * 60 * 1000); // 5 minutes
};

const stopPolling = () => {
    // console.log(`stopPolling: ${dayjs().format("HH:mm:ss")}`, pollInterval, $store.user.id);
    if (pollInterval === undefined) {
        return;
    }

    window.clearInterval(pollInterval);
    pollInterval = undefined;
};

watch(
    () => $store.user.id,
    (userId) => {
        // console.log(`watch userId: ${dayjs().format("HH:mm:ss")}`, userId, pollInterval);
        if (userId) {
            startPolling();

            return;
        }

        stopPolling();
    },
    {immediate: true},
);

onBeforeUnmount(stopPolling);
</script>

<template>
    <Transition>
        <div
            v-if="show"
            class="fixed inset-x-0 bottom-3 z-50 mx-auto max-w-sm rounded-md bg-stone-900/90 p-4 text-white shadow-lg shadow-black backdrop-blur-sm"
        >
            <h3 class="font-display text-lg font-bold text-askr-green-500">Update available</h3>
            <p class="mt-1">A new version of the app is ready.</p>
            <div class="mt-4 flex justify-end">
                <Button class="rounded bg-askr-green px-4 py-2 font-bold text-white" @click="reload">Reload</Button>
            </div>
        </div>
    </Transition>
</template>
